"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var currencySlice_1 = require("../../features/currencies/currencySlice");
var currencyConverter_1 = require("../../helpers/currencyConverter");
var MonthlyMortgage = function (_a) {
    var value = _a.value;
    var hasMortgage = !!value.length;
    var rate = react_redux_1.useSelector(currencySlice_1.selectExchangeRate);
    var all = react_redux_1.useSelector(currencySlice_1.selectAllExchangeRates);
    var currency = react_redux_1.useSelector(currencySlice_1.selectCurrentCurrency);
    var convertedCurrency = hasMortgage && currencyConverter_1.convertToCurrency(value, rate, all, currency);
    if (!hasMortgage) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement("div", null,
        (value === null || value === void 0 ? void 0 : value.length) && react_1.default.createElement("i", { className: "icon-ic-" + currency }),
        convertedCurrency));
};
exports.default = MonthlyMortgage;
